var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from "hanako-ts/dist-legacy/Component";
export class Story extends Component {
    constructor() {
        super('Story', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            const headerHeight = $('header').height();
            $(window).on('scroll', () => {
                $('.article').each((article) => {
                    const titleHeight = article.find('.row-title').height();
                    if (article.viewportPosition().y < headerHeight - titleHeight && article.viewportPosition().y + article.height() + titleHeight > 0) {
                        article.find('.tools').addClass('fixed');
                        article.find('.tools').css('top', headerHeight + 'px', 'important');
                    }
                    else {
                        article.find('.tools').removeClass('fixed');
                        article.find('.tools').css('top', '10px');
                    }
                });
            });
            this.success();
        });
    }
}
